import React from "react";
import { Modal } from "sprint-common-web";

import { DistributorsDataProvider } from "../../../common/data/lookup-data-providers/DistributorsDataProvider";
import { LookupOrderItem } from "./LookupOrderItem";
import { LookupOrdersList } from "./LookupOrdersList";

type LookupOrdersModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onClick: (item: LookupOrderItem) => void;
};

export const LookupOrdersModal = (props: LookupOrdersModalProps): JSX.Element => {
    return (
        <Modal
            isOpen={props.isOpen}
            headerText="Lookup orders"
            onDismiss={props.onClose}
            size="lg"
            displayCloseButton={true}
        >
            <DistributorsDataProvider>
                <LookupOrdersList onClick={props.onClick} />
            </DistributorsDataProvider>
        </Modal>
    );
};
